import { useMutation, useQueryClient } from '@tanstack/react-query';
import { cancelScheduledPlanChange } from '@/services/subscription.service';
import { queryKeys } from '@/hooks/queries/keys';
import type { SubscriptionDto } from '@/types/subscription';

export const useCancelScheduledPlanChange = () => {
    const queryClient = useQueryClient();
    return useMutation<SubscriptionDto, unknown, void>({
        mutationFn: cancelScheduledPlanChange,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.subscription.me() });
            queryClient.invalidateQueries({ queryKey: queryKeys.subscription.changeHistory() });
        },
    });
};
